export const CompanyInPortsType = {
  Courier: false,
  GarbageDisposal: true,
};
